import { AppState } from "AppState";

export const versionInfoSelector = (state: AppState): string =>
	state.versionInfo;
